import { ERequestType } from "../api";
import { ERoutes } from "../ERoutes";
export function getSearchRouteStr(requestTypeCode) {
  switch (requestTypeCode) {
    case ERequestType.WorkAttestRequest:
      return `${ERoutes.workAttestationRequest}`;
    case ERequestType.WorkbookRequest:
      return `${ERoutes.workbookRequest}`;
    case ERequestType.DogOwnershipChangeRequest:
      return `${ERoutes.rsh}`;
    case ERequestType.KennelImportRequest:
      return `${ERoutes.affixRequest}`;
    case ERequestType.KennelOwnershipChangeRequest:
      return `${ERoutes.affixRequest}`;
    case ERequestType.NewKennelRequest:
      return `${ERoutes.affixRequest}`;
    case ERequestType.KennelExportRequest:
      return `${ERoutes.affixRequest}`;
    case ERequestType.KennelNameChangeRequest:
      return `${ERoutes.affixRequest}`;
    case ERequestType.DogTempOwnershipChangeRequest:
      return `${ERoutes.tempRsh}`;
    case ERequestType.BroodRequest:
      return `${ERoutes.broodRequest}`;
    case ERequestType.PedigreeDuplicataRequest:
      return `${ERoutes.pedigreeDuplicata}`;
    case ERequestType.CompetitionRequest:
      return `${ERoutes.competitionRequest}`;
    case ERequestType.PedigreeRequest:
      return `${ERoutes.rish}`;
    case ERequestType.TitleRequest:
      return `${ERoutes.titleRequests}`;
    case ERequestType.ImportRequest:
      return `${ERoutes.importRequest}`;
    case ERequestType.DysplasiaRequest:
      return `${ERoutes.dysplasiaRequest}`;
    case ERequestType.HealthTestRequest:
      return `${ERoutes.healthTestRequest}`;
    case ERequestType.MembershipRequest:
      return `${ERoutes.membershipRequest}`;
    case ERequestType.MiscellaneousRequest:
      return `${ERoutes.miscellaneousRequest}`;
    case ERequestType.ExpatriationRequest:
      return `${ERoutes.expatriationRequest}`;
  }
}
